


















































import { Component, Ref, Vue } from 'vue-property-decorator';
import {Action} from 'vuex-class';
import { cloneDeep, isEqual } from "lodash";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import { getTranslatedParams } from '@/utils/notify-utils';
import {InputWings, TextareaWings} from "wings-ui-components";
import { ActionLog } from '@/store/auth/types';
import { PoolItem, PoolItemImpl } from '@/store/settings/pools/types';
import { Route } from 'vue-router';

@Component ({components:{InputWings, TextareaWings}})
export default class Pool extends Vue {
  @Ref('validator') validator: any;

  @Action('getPoolItem') actionGetItem: any;
  @Action('savePool') actionSave: any;
  @Action('deletePool') actionDelete: any;
  @Action('actionLog') actionLog: any;

  defaultItem(): PoolItem {
    return new PoolItemImpl();
  }

  private item: PoolItem = this.defaultItem();
  private itemSaved: PoolItem = this.defaultItem();
  private logObject: ActionLog = {};


  async created() {
    if (this.$route.params.id) {
      try {
        const data = await this.actionGetItem(Number(this.$route.params.id));
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: 'Viewing',
          action_status: 'success',
          object_type: 'Page',
          object_name: this.item.name
        };
        await this.actionLog(this.logObject);
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: 'failed'});
      }
    }
  }

  back(): void {
    this.$router.push('/settings/pools/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? 'Editing' : 'Creation',
            action_status: 'success',
            object_type: 'Page',
            object_name: this.item.name,
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSave(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: 'failed'});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: 'Removal',
          action_status: 'success',
          object_type: 'Page',
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: 'failed'});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:Route, from:Route, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
